module.exports = __webpack_public_path__ + "img/21.82726468.jpg";